module.exports = __webpack_public_path__ + "img/ymc-thumb5.9579ec71.png";